import React from 'react';
import { Button } from 'reactstrap';

const ReportActions = ({
  mind_pattern_unsaved,
  user,
  handleConfirmSave,
  getFullReportMP,
  handleRetake,
}) => {
  return (
    <div className='text-center border-top pt-3 pt-md-4 pb-2 bg-white report-actions'>
      {mind_pattern_unsaved && (
        <Button
          onClick={handleConfirmSave}
          color="green-light"
          size="lg"
          className="mx-2 mb-3"
        >
            <i className='mr-2 pb-1'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.3472 5.66021L7.34717 14.6602C7.26878 14.7389 7.17563 14.8013 7.07308 14.8439C6.97052 14.8865 6.86056 14.9084 6.74951 14.9084C6.63846 14.9084 6.5285 14.8865 6.42594 14.8439C6.32338 14.8013 6.23024 14.7389 6.15185 14.6602L2.21435 10.7227C2.13587 10.6442 2.07361 10.5511 2.03113 10.4485C1.98866 10.346 1.9668 10.2361 1.9668 10.1251C1.9668 10.0141 1.98866 9.90415 2.03113 9.80161C2.07361 9.69906 2.13587 9.60589 2.21435 9.5274C2.29284 9.44892 2.38602 9.38666 2.48856 9.34418C2.59111 9.30171 2.70102 9.27984 2.81201 9.27984C2.92301 9.27984 3.03291 9.30171 3.13546 9.34418C3.23801 9.38666 3.33118 9.44892 3.40967 9.5274L6.75021 12.8679L15.1533 4.46631C15.3118 4.3078 15.5267 4.21875 15.7509 4.21875C15.9751 4.21875 16.1901 4.3078 16.3486 4.46631C16.5071 4.62482 16.5961 4.8398 16.5961 5.06396C16.5961 5.28813 16.5071 5.50311 16.3486 5.66162L16.3472 5.66021Z" fill="#332D2D"/>
                </svg>
            </i>
          Submit Answers
        </Button>
      )}

      {user && user.access_pdf_mp && !mind_pattern_unsaved && (
        <Button
          onClick={getFullReportMP}
          color="green-light"
          size="sm"
          className="mx-2 mb-3"
        >
          <i className="mr-2 pb-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" fill="currentColor" viewBox="0 0 11 12">
              <path d="M11,6.9v3.5c0,0.2-0.1,0.3-0.2,0.5C10.7,11,10.5,11,10.3,11H0.7c-0.2,0-0.3-0.1-0.5-0.2C0.1,10.7,0,10.5,0,10.4
              V6.9c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2S1,6.3,1.2,6.4c0.1,0.1,0.2,0.3,0.2,0.5v2.8h8.3V6.9c0-0.2,0.1-0.3,0.2-0.5
              c0.1-0.1,0.3-0.2,0.5-0.2s0.3,0.1,0.5,0.2C10.9,6.5,11,6.7,11,6.9z M5,7.3l2.2-2.2L6.2,5.3V0.7z"/>
            </svg>
          </i>
          Mind Pattern Report
        </Button>
      )}

      <Button
        color="outline-green-light"
        size="sm"
        className={`mx-2 mb-3 ${user?.has_mp_blocked ? 'disabled' : ''}`}
        onClick={handleRetake}
      >
        <i className="mr-2">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"  xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3435 3.06196V5.68696C13.3435 5.86101 13.2744 6.02793 13.1513 6.151C13.0283 6.27407 12.8613 6.34321 12.6873 6.34321H10.0623C9.88825 6.34321 9.72133 6.27407 9.59826 6.151C9.47519 6.02793 9.40605 5.86101 9.40605 5.68696C9.40605 5.51291 9.47519 5.34599 9.59826 5.22292C9.72133 5.09985 9.88825 5.03071 10.0623 5.03071H10.9975L9.95839 4.08024C9.95128 4.07368 9.94417 4.06711 9.93761 4.06C9.45583 3.57851 8.86309 3.22281 8.21155 3.02419C7.56001 2.82557 6.86964 2.79013 6.20118 2.92097C5.53273 3.05182 4.90668 3.34495 4.37811 3.77457C3.84955 4.20419 3.43467 4.75713 3.16999 5.38474C2.9053 6.01235 2.79892 6.69539 2.86021 7.37377C2.92149 8.05215 3.14856 8.70507 3.52144 9.27508C3.89432 9.84509 4.40158 10.3147 4.99858 10.6427C5.59558 10.9706 6.26403 11.1468 6.94511 11.1557H6.9998C8.06069 11.1583 9.08189 10.7525 9.85175 10.0226C9.9783 9.903 10.1472 9.83858 10.3212 9.8435C10.4953 9.84842 10.6602 9.92228 10.7798 10.0488C10.8994 10.1754 10.9638 10.3442 10.9589 10.5183C10.954 10.6923 10.8801 10.8573 10.7535 10.9769C9.74013 11.9374 8.3961 12.4714 6.9998 12.4682H6.92488C6.02967 12.4556 5.15125 12.2234 4.36675 11.792C3.58225 11.3606 2.91567 10.7431 2.42553 9.99392C1.93539 9.24471 1.63669 8.38661 1.55565 7.49499C1.47462 6.60337 1.61372 5.70549 1.96076 4.88019C2.3078 4.05489 2.85215 3.32741 3.54602 2.76163C4.23989 2.19586 5.06205 1.80909 5.94032 1.63529C6.81858 1.46148 7.72609 1.50597 8.58315 1.76483C9.44021 2.02368 10.2206 2.489 10.8558 3.11993L12.031 4.19508V3.06196C12.031 2.88791 12.1002 2.72099 12.2233 2.59792C12.3463 2.47485 12.5133 2.40571 12.6873 2.40571C12.8613 2.40571 13.0283 2.47485 13.1513 2.59792C13.2744 2.72099 13.3435 2.88791 13.3435 3.06196Z" fill="#332D2D"/>
          </svg>

        </i>
        Retake Assessment
      </Button>
    </div>
  );
};

export default ReportActions;
